/**
 * Created by lu on 2018/4/10.
 */
var nb = require('../../../../nb');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            this.onChange('id', function (inEvent, inId) {  //
                this.set('href', 'productList.html?type=' + inId);
            }, this);

            this.onChange('counter', function (inEvent, inValue) {  //
                return inValue.toString();
            }, this, {before: true});

            nb.model.onChange('changeLanguageReady', function (inEvent, inData) {
                if (inData == 'cn') {
                    this.set('itemsText', '款');
                } else {
                    this.set('itemsText', 'items');
                }
            }, this);

        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/wineType/TypeItem.js
// module id = 532
// module chunks = 6